import { useMutation } from 'react-query';
import { setNewPassword, SetUserPasswordDTO } from '@higo/api';
import { useMicrositeApiContext } from 'contexts/MicrositeApiContext';

export const useSetNewPasswordMutation = () => {
  const { baseAxios } = useMicrositeApiContext();

  return useMutation((dto: SetUserPasswordDTO) =>
    setNewPassword(baseAxios)(dto),
  );
};
